export const Theme = {
  colors: {
    PrimaryGreen: "#037540",
    SecondaryGreen: "#056B54",
    Gray: "#bebebe",
    TextBlack: "#000",
    TextGray: "#BCBCBC",
    White: "#fff",
  },
  FontSizes: {
    Title: "2.2rem",
    ContentText: "0.9rem",
    ButtonText: "1.1rem",
  },
};
